import registry from '../data/animal-registry.json' with {type:'json'};
import {validateAnimalRegistry} from './animal-registry-contract.js';
function freezeTree(value){if(value&&typeof value==='object'){Object.values(value).forEach(freezeTree);Object.freeze(value);}return value;}
/** JSON-compatible source of identity, review scope and selected export metadata. */
export const ANIMAL_REGISTRY=freezeTree(validateAnimalRegistry(registry));
export function findAnimalEntry(family){return ANIMAL_REGISTRY.entries.find(entry=>entry.family===family)??null;}
